module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	'use strict';
	
	require('script!imagesloaded/imagesloaded.pkgd');
	require('script!swipe-js/swipe');
	require('script!masonry/dist/masonry.pkgd');
	require('script!jquery-counter/src/jquery.counter');

	require('jquery-ui/ui/core');
	require('jquery-ui/ui/widget');
	require('jquery-ui/ui/dialog');

	require('widget/autocomplete2')(fox);

	require('fox-dynamic-injection!fox-template-loader!../../../model/common/templates/promo/copyright_policy.tpl')(fox);
	//require('fox-dynamic-injection!fox-template-loader!../../../model/common/templates/promo/privacyPolicy.tpl')(fox);

	//require('../../../../../common-components/CCPA/templates/mc/doc.a.tpl')(fox);
	require('../../../../../common-components/CCPA/templates/mc.a.tpl')(fox);

	require('../../../../../common-components/popupWidget')(fox);
	
	require('../components/ccpa')(fox);

	require('../../../../../common-components/CCPA/widget/form')(fox);
	require('../../../../../common-components/CCPA/widget/page')(fox);

})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./dependencies/dependencies.js
// module id = 52
// module chunks = 0